export const BRAND_ORANGE = '#ff7401';

export const BRAND_PRIMARY = BRAND_ORANGE;
